// Merchandising carousel slider
import { Splide } from '@splidejs/splide';

$(document).ready(() => {
  document.querySelectorAll('.nCarousel').forEach((element) => {
    new Splide(element, {
      type: 'loop',
      pagination: true,
      arrows: true,
      speed: 300,
      perPage: 4,
      perMove: 1,
      gap: '1rem',
      breakpoints: {
        1200: {
          perPage: 3,
        },
        850: {
          perPage: 2,
        },
        500: {
          perPage: 1,
        },
      },
    }).mount();
  });
});

// Brand carousel slider
$(document).ready(() => {
  document.querySelectorAll('.nCarousel-brands').forEach((element) => {
    new Splide(element, {
      type: 'loop',
      pagination: false,
      arrows: true,
      speed: 300,
      autoplay: true,
      interval: 5000,
      perPage: 6,
      perMove: 1,
      gap: '1rem',
      breakpoints: {
        1400: {
          perPage: 5,
        },
        1200: {
          perPage: 4,
        },
        1000: {
          perPage: 3,
        },
        600: {
          perPage: 2,
        },
        400: {
          perPage: 1,
        },
      },
    }).mount();
  });
});

// Timeline sliders initialization
$(document).ready(() => {
  // Background slider
  document.querySelectorAll('.backgound-slider').forEach((element) => {
    new Splide(element, {
      type: 'loop',
      pagination: false,
      arrows: false,
      speed: 300,
      autoplay: true,
      interval: 5000,
      perPage: 1,
      perMove: 1,
    }).mount();
  });

  // Initialize year and history sliders with sync
  const yearSliders = document.querySelectorAll('.year-slider');
  const historySliders = document.querySelectorAll('.history-slider');

  yearSliders.forEach((yearElement, index) => {
    const historyElement = historySliders[index];
    if (!historyElement) return;

    const yearSplide = new Splide(yearElement, {
      type: 'slide',
      pagination: false,
      arrows: false,
      speed: 300,
      perPage: 5,
      perMove: 5,
      isNavigation: true,
      breakpoints: {
        1200: {
          perPage: 4,
        },
        991: {
          perPage: 3,
        },
        768: {
          perPage: 2,
        },
        500: {
          perPage: 1,
        },
      },
    });

    const historySplide = new Splide(historyElement, {
      type: 'slide',
      pagination: true,
      arrows: true,
      speed: 300,
      perPage: 5,
      perMove: 5,
      breakpoints: {
        1200: {
          perPage: 4,
        },
        991: {
          perPage: 3,
        },
        768: {
          perPage: 2,
        },
        500: {
          perPage: 1,
        },
      },
    });

    // Mount and syncboth sliders
    yearSplide.sync(historySplide);
    yearSplide.mount();
    historySplide.mount();
  });
});
